module.exports = __webpack_public_path__ + "75b6bc0f2bc11998b85c27544c04b1bc.png";